module.exports = __webpack_public_path__ + "img/corrugatedBox14.ce499533.jpg";